import request from "superagent";
import nocache from "superagent-no-cache";
import * as Actions from './actions'
import log from 'components/utils/Logger';
import {combineActions, handleAction} from "redux-actions";

export const connection = store => next => action => {
    next(action);
    // POSTリクエスト
    if (action.type.match("^CONNECTION") && action.meta.fetch) {
        if (action.payload.method !== null && action.payload.method === "post") {
            let query = {};
            if (action.payload.hasOwnProperty("query")) {
                query = action.payload.query;
            }
            request
                .post(action.payload.api)
                .query(query)
                .send(action.payload.data)// data string
                .use(nocache) // Prevents caching of *only* this request
                .end((err, res) => {
                    if (!err) {
                        next(Object.assign(action, {
                                payload: {
                                    ...res.body
                                },
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.SUCCESS
                                }
                            })
                        );
                    } else {
                        next(Object.assign(action, {
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.ERROR
                                }
                            })
                        );
                    }
                });
        }
        ;

        // GETリクエスト
        if (action.payload.method !== null && action.payload.method === 'get') {
            let query = {};
            if (action.payload.hasOwnProperty("query")) {
                query = action.payload.query;
            }
            request
                .get(action.payload.api)
                .query(query)  // query string
                .use(nocache) // Prevents caching of *only* this request
                .end((err, res) => {
                    if (!err) {
                        next(Object.assign(action, {
                                payload: {
                                    ...res.body
                                },
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.SUCCESS
                                }
                            })
                        );
                    } else {
                        next(Object.assign(action, {
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.ERROR
                                }
                            })
                        );
                    }
                });
        }

        // PUTリクエスト
        if (action.payload.method !== null && action.payload.method === "put") {
            let query = {};
            if (action.payload.hasOwnProperty("query")) {
                query = action.payload.query;
            }
            request
                .put(action.payload.api)
                .query(query)
                .send(action.payload.data)// data string
                .use(nocache) // Prevents caching of *only* this request
                .end((err, res) => {
                    if (!err) {
                        next(Object.assign(action, {
                                payload: {
                                    ...res.body
                                },
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.SUCCESS
                                }
                            })
                        );
                    } else {
                        next(Object.assign(action, {
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.ERROR
                                }
                            })
                        );
                    }
                });

        }

        // DELETEリクエスト
        if (action.payload.method !== null && action.payload.method === 'delete') {
            request
                .delete(action.payload.api)
                .query(action.payload.query)  // query string
                .use(nocache) // Prevents caching of *only* this request
                .end((err, res) => {
                    if (!err) {
                        next(Object.assign(action, {
                                payload: {
                                    ...res.body
                                },
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.SUCCESS
                                }
                            })
                        );
                    } else {
                        next(Object.assign(action, {
                                meta: {
                                    fetch: false,
                                    status: Actions.statusEnum.ERROR
                                }
                            })
                        );
                    }
                });
        }
    }
};


export const dataStore = store => next => action => {
    if (action.type.match("^CONNECTION/") && !action.meta.fetch) {
        if (action.meta.status === Actions.statusEnum.SUCCESS) {
            //通信自体は成功　is_succeed毎に処理をする必要性あり
            //SUCCESS
            switch (action.type) {
                case Actions.http.connection.mapStatus.get().type:
                    store.dispatch(
                        Actions.data.mapStatus(action.payload.result.map_statuses)
                    );
                    store.dispatch(
                        Actions.data.mapLabels(action.payload.result.map_labels)
                    );
                    store.dispatch(
                        Actions.data.stockStatus(action.payload.result.stock_statuses)
                    )
                    break;
                case Actions.http.connection.bundles().type:
                    //bundle読み込み終了後にcurrent情報の取得
                    store.dispatch(
                        Actions.http.connection.authentication.current()
                    );
                    log.debug(action.payload.result)
                    store.dispatch(
                        Actions.data.regions(action.payload.result.regions)
                    );
                    store.dispatch(
                        Actions.data.settings(action.payload.result.settings)
                    );
                    store.dispatch(
                        Actions.data.tenants(action.payload.result.tenants)
                    );
                    store.dispatch(
                        Actions.data.timeGroups(action.payload.result.time_groups)
                    );
                    break;
                case Actions.http.connection.authentication.current().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        store.dispatch(
                            Actions.data.session(action.payload.is_succeed)
                        );
                        store.dispatch(
                            Actions.data.administrator(action.payload.result.administrator)
                        );
                        store.dispatch(
                            Actions.data.administratorMenus(action.payload.result.administrator_menus.parent_menus)
                        );
                        store.dispatch(
                            Actions.data.target(action.payload.result.target)
                        )
                    } else {
                        store.dispatch(
                            Actions.data.session(false)
                        );
                    }
                    break;

                case Actions.http.connection.settings.get().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        store.dispatch(
                            Actions.data.settings(action.payload.result.settings)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.settings({})
                        );
                    }
                    break;
                case Actions.http.connection.settings.region.get().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        store.dispatch(
                            Actions.data.regionSettings(action.payload.result.settings)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.regionSettings({})
                        );
                    }
                    break;
                case Actions.http.connection.questionnaires.get().type:
                case Actions.http.connection.questionnaires.put().type:
                case Actions.http.connection.questionnaires.post().type:
                case Actions.http.connection.questionnaires.delete().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        store.dispatch(
                            Actions.data.questionnaires(action.payload.result)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.questionnaires([])
                        );
                    }
                    break;

                case Actions.http.connection.authentication.login().type:
                    if (action.payload.hasOwnProperty("is_succeed")) {
                        store.dispatch(
                            Actions.data.session(action.payload.is_succeed)
                        );
                        if (action.payload.is_succeed) {
                            store.dispatch(
                                Actions.data.administrator(action.payload.result.administrator)
                            );
                            store.dispatch(
                                Actions.data.administratorMenus(action.payload.result.administrator_menus.parent_menus)
                            );
                        }
                    } else {
                        store.dispatch(
                            Actions.data.session(false)
                        );
                    }
                    break;

                case Actions.http.connection.schedules.week.get().type:
                case Actions.http.connection.schedules.week.put().type:
                case Actions.http.connection.schedules.week.all().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        //todo array変換がありえる
                        const schedules = action.payload.result.hasOwnProperty("schedule") ? action.payload.result.schedule.times : {};
                        log.debug(schedules);
                        const arr = [];
                        for (const prop in schedules) {
                            arr.push(schedules[prop]);
                        }
                        store.dispatch(
                            Actions.data.weekSchedules(arr)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.weekSchedules([])
                        );
                    }
                    break;

                case Actions.http.connection.schedules.month.get().type:
                case Actions.http.connection.schedules.month.put().type:
                case Actions.http.connection.schedules.month.available().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        //todo array変換がありえる
                        const schedules = action.payload.result.hasOwnProperty("schedule") ? action.payload.result.schedule.times : {};
                        log.debug(schedules);
                        const arr = [];
                        for (const prop in schedules) {
                            arr.push(schedules[prop]);
                        }
                        store.dispatch(
                            Actions.data.monthAvailable(action.payload.result.schedule.schedule_month_available_flag)
                        )
                        store.dispatch(
                            Actions.data.monthSchedules(arr)
                        );
                    } else {

                        store.dispatch(
                            Actions.data.monthAvailable(false)
                        )
                        store.dispatch(
                            Actions.data.monthSchedules([])
                        );
                    }
                    break;

                case Actions.http.connection.openings().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        const openings = action.payload.result.hasOwnProperty("openings") ? action.payload.result.openings : [];
                        log.debug(openings);
                        store.dispatch(
                            Actions.data.openings(openings)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.openings([])
                        );
                    }
                    break;

                case Actions.http.connection.tickets.get().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        log.debug(action);
                        const tickets =
                            action.payload.result.hasOwnProperty("tickets")
                                ?
                                action.payload.result.tickets : [];
                        log.debug(tickets);
                        store.dispatch(
                            Actions.data.tickets(tickets)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.tickets([])
                        );
                    }
                    break;


                case Actions.http.connection.items.get().type:
                case Actions.http.connection.items.post().type:
                case Actions.http.connection.items.put().type:
                case Actions.http.connection.items.delete().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        const items =
                            action.payload.result.hasOwnProperty("items")
                                ?
                                action.payload.result.items : [];
                        log.debug(items);
                        store.dispatch(
                            Actions.data.items(items)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.items([])
                        );
                    }
                    break;

                case Actions.http.connection.areas.get().type:
                case Actions.http.connection.areas.post().type:
                case Actions.http.connection.areas.put().type:
                case Actions.http.connection.areas.delete().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        const areas =
                            action.payload.result.hasOwnProperty("areas")
                                ?
                                action.payload.result.areas : [];
                        log.debug(areas);
                        store.dispatch(
                            Actions.data.areas(areas)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.areas([])
                        );
                    }
                    break;
                case Actions.http.connection.logs.get().type:
                    if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                        const logs =
                            action.payload.result ? action.payload.result : [];
                        log.debug(logs);
                        store.dispatch(
                            Actions.data.logs(logs)
                        );
                    } else {
                        store.dispatch(
                            Actions.data.logs([])
                        );
                    }
                    break;


                case Actions.http.connection.authentication.logout().type:
                    store.dispatch(
                        Actions.data.session(false)
                    );
                    //todo checkinのみの絞込
                    document.location.href = "logout://logout";

                    break;

                default:

                    log.debug(action);

                    break;
            }

            //汎用通信処理でis_succeedではない場合はFAILUREStatusで上書き
            if (action.payload.hasOwnProperty("is_succeed") && action.payload.is_succeed) {
                next(action);
            } else {
                next(Object.assign(action, {
                        meta: {
                            fetch: false,
                            status: Actions.statusEnum.FAILURE
                        }
                    })
                );

                switch(action.type){
                    case "CONNECTION/AUTHENTICATION/CURRENT":
                        break;
                    default:
                        store.dispatch(
                            Actions.data.failure(action.payload,true)
                        )
                        break;
                }
            }

        } else if (action.meta.status === Actions.statusEnum.ERROR) {
            //ERROR
            next(action);
        }
    }else{
        next(action)
    }
};




// WEBPACK FOOTER //
// ./src/redux/middleware.js